module.exports = __webpack_public_path__ + "static/freescantrio7lines-71632b2c4ca21b4c6eb3e41585fdff59.jpg";